import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TransactionDto } from '@dto/transactionDto';
import { DeliveryNote } from '@models/deliveryNote';
import { TableColumn } from '@models/tableColumn';
import { TableOptions } from '@models/tableOptions';
import { Transaction } from '@models/transaction';
import { DeliveryNotesService } from '@services/entity/delivery-notes.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { FormService } from '@services/form/form.service';
import { CustomersService } from '@services/entity/customers.service'
import { ToastService } from '@services/toast/toast.service';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import { ThousandPipe } from 'src/app/pipes/thousand.pipe';
import Swal from 'sweetalert2';
import { CustomerDto } from '../../../../dto/customerDto';
import { UsersService } from '@services/entity/users.service';
import { UserDto } from '../../../../dto/userDto';

@Component({
  selector: 'app-create-delivery-csv',
  templateUrl: './create-delivery-csv.component.html',
  styleUrls: ['./create-delivery-csv.component.scss']
})
export class CreateDeliveryCSVComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'CreateDeliveryCSVComponent';

  @Input() public transactions: TransactionDto[];
  @Input() public userId: string;
  @Input() public customerId: number;

  @Output() newEntityEvent = new EventEmitter<DeliveryNote>();

  public entities: TransactionDto[];

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn1:Trans-ID`, property: 'transactionId' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn2:Vorname`, property: 'userFirstName' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn3:Nachname`, property: 'userLastName' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn4:Ladestation`, property: 'chargingStationName' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn5:Lademenge in kWh`, property: 'meterAmount', options: { columnPipe: { pipe: new ThousandPipe(new DecimalPipe('de-DE')) } } },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn6:Datum`, property: 'startTimestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
  ];

  public tableOptions: TableOptions = { hideActions: true, hideSearch: true, showCheckboxes: true };

  public exportRows: TransactionDto[];
  public customer: UserDto;
  public user: UserDto;

  constructor(
    public deliveryNotesService: DeliveryNotesService,
    public customerService: CustomersService,
    public usersService: UsersService,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector
  ) {
    super(deliveryNotesService, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tableFunctions.pageSize = 999999;
    this.tableFunctions.sortColumn = 'transactionId';
    this.tableFunctions.sortDirection = 'desc';
    this.customerService.getCustomer(this.customerId).subscribe(result => {
      this.usersService.getMasterUserByCustomerId(result.id).subscribe(res => {
        this.user = res;
        this.userId = this.user.id;
        console.log(this.user);
      })
    })

    this.entities.forEach(e => {
      this.tableFunctions.selectedEntities.push(e);
    })

    this.createForm();
  }

  initializeEntities() {
    this.entities = this.transactions;
    if (this.userId == 'ERoamingcharge' || this.userId == 'QRCodecharge' || this.userId == 'Terminalcharge' || this.userId == 'freecharge') {
      this.exportRows = this.entities.map(t => ({
        ...t,
        // für den Export eine stabile Anzeige-Logik
        userFirstName: this.getSimulatedUser(t) ?? t.userId ?? 'unassigned',
        // optional: für Tools, die eine Id brauchen:
        userId:null,
        updateValues: t.updateValues,
        getPrimaryKey: t.getPrimaryKey

      }));
    }
    this.entities = this.exportRows;
    super.setupTable();
  }

  getSimulatedUser(t: TransactionDto) {
    if (t.isFreeCharge) return 'freecharge';
    if (t.paymentIntentId) return 'QRCodecharge';
    if (t.sessionId) return 'ERoamingcharge';
    if (t.hecId) return 'Terminalcharge';
    return null;
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      deliveryNoteNumber: new UntypedFormControl(),
    });
  }

  onSubmit(formValue, download: boolean = false) {
    download = true;
    var deliveryNote = new DeliveryNote(formValue);
    deliveryNote.transactions = this.tableFunctions.selectedEntities as Transaction[];
    deliveryNote.customerId = this.customerId;

    this.deliveryNotesService.createEntity(deliveryNote).subscribe(result => {
      this.newEntityEvent.emit(deliveryNote);
      if(download)
       this.downloadCSV(result.id, result.deliveryNoteNumber);
    }, error => {
      this.toastService.error($localize`:@@CreateDeliveryNoteErrorTitle:Fehler beim Erstellen der CSV-Datei.`)
      this.messageService.setError(error);
    })

  }

  downloadCSV(deliveryNoteId:number, deliveryNoteNumber:string ) {
    this.toastService.success(`CSV-Datei wird heruntergeladen...`,2500,true)
    console.log("deliveryNoteId",deliveryNoteId);
    console.log("deliveryNoteNumber",deliveryNoteNumber);

    this.deliveryNotesService.getDeliveryNoteAsCSV(deliveryNoteId).subscribe((response: any) => {
      try {
        const file = new Blob([response], { type: 'text/csv' });
        const fileUrl = URL.createObjectURL(file);

        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileUrl;
        a.download = deliveryNoteNumber;
        a.click();
      } catch (error) {
        console.error(error);
        this.toastService.error(`CSV-Datei konnte nicht heruntergeladen werden.`, 0, true)
      } finally {
        this.toastService.clear()
      }
    }, error => {
      console.error(error);
      this.toastService.error(`CSV-Datei konnte nicht heruntergeladen werden.`, 0, true)
    })

  }

}
